










import { Component, Vue, Prop } from 'vue-property-decorator'
import { AgendamentoCirurgia } from '@/types/_'

type AgendamentoComPrimeiroDiagnostico = Pick<AgendamentoCirurgia, 'id' | 'dataPrimeiroDiagnostico'>

@Component
export default class ComponentPrimeiroDiagnosticoBadge extends Vue {
  @Prop({ default: () => ({ id: '', dataPrimeiroDiagnostico: null }), required: true }) agendamento: AgendamentoComPrimeiroDiagnostico
}
